import { importCDC, importCOVIDHosp, importCOVIDcast, importFluSurv, importFluView, importGFT, importGHT, importNIDSSDenque, importNIDSSFlu, importNowcast, importQuidel, importSensors, importTwitter, importWiki, } from './api/EpiData';
import DataSet, { DataGroup, DEFAULT_GROUP, flatten, SAMPLE_DATASET, DEFAULT_VIEWPORT } from './data/DataSet';
import EpiDate from './data/EpiDate';
import EpiPoint from './data/EpiPoint';
const DEFAULT_VALUES = {
    group: DEFAULT_GROUP,
    active: [SAMPLE_DATASET],
    viewport: DEFAULT_VIEWPORT,
    showPoints: false,
};
const lookups = {
    cdc: importCDC,
    cdcp: importCDC,
    covid_hosp: importCOVIDHosp,
    covidcast: importCOVIDcast,
    flusurv: importFluSurv,
    fluview: importFluView,
    gft: importGFT,
    ght: importGHT,
    nidss_denque: importNIDSSDenque,
    nidss_flu: importNIDSSFlu,
    nowcast: importNowcast,
    quidel: importQuidel,
    sensors: importSensors,
    twtr: importTwitter,
    twitter: importTwitter,
    wiki: importWiki,
};
const argOrders = {
    cdc: ['auth', 'locations'],
    cdcp: ['auth', 'locations'],
    covidcast: ['data_source', 'signal', 'time_type', 'geo_type', 'geo_value'],
    covid_hosp: ['states', 'issues'],
    flusurv: ['locations', 'issues', 'lag'],
    fluview: ['regions', 'issues', 'lag', 'auth'],
    gft: ['locations'],
    ght: ['auth', 'locations', 'query'],
    nidss_dengue: ['locations'],
    nidss_flu: ['regions', 'issues', 'lag'],
    nowcast: ['locations'],
    quidel: ['auth', 'locations'],
    sensors: ['auth', 'names', 'locations'],
    twitter: ['auth', 'locations', 'resolution'],
    twtr: ['auth', 'locations', 'resolution'],
    wiki: ['articles', 'resolution', 'hour'],
};
function endpointParams(endpoint, params) {
    const r = {};
    const args = argOrders[endpoint];
    if (args) {
        args.forEach((arg, i) => {
            r[arg] = params[i];
        });
    }
    return r;
}
function patchDataSet(title, color) {
    return (dg) => {
        if (!dg) {
            return null;
        }
        const datasets = flatten(dg);
        const d = datasets.find((di) => di.title === title);
        if (d) {
            d.color = color;
        }
        return d;
    };
}
export function initialLoader(datasets) {
    return (add) => {
        const resolvedDataSets = [];
        const loadingDataSets = new Map();
        function loadImpl(title, color, endpoint, params) {
            const func = lookups[endpoint];
            if (!func) {
                console.warn('cannot load data', params);
                return;
            }
            const key = `${endpoint}:${JSON.stringify(params)}`;
            const existing = loadingDataSets.get(key);
            if (existing) {
                resolvedDataSets.push(existing.then(patchDataSet(title, color)));
            }
            else {
                const loadingDataSet = func(params);
                loadingDataSets.set(key, loadingDataSet);
                resolvedDataSets.push(loadingDataSet.then(patchDataSet(title, color)));
            }
        }
        for (const ds of datasets) {
            if (ds.title === SAMPLE_DATASET.title) {
                SAMPLE_DATASET.color = ds.color;
                resolvedDataSets.push(SAMPLE_DATASET);
                continue;
            }
            if (ds.params && ds.params._type === 'line') {
                const d = new DataSet([
                    new EpiPoint(EpiDate.fromIndex(ds.params.x0), ds.params.v0),
                    new EpiPoint(EpiDate.fromIndex(ds.params.x1), ds.params.v1),
                ], ds.title, ds.params, ds.color);
                add(d);
                resolvedDataSets.push(d);
                continue;
            }
            if (ds.params && ds.params._endpoint) {
                loadImpl(ds.title, ds.color, ds.params._endpoint, ds.params);
            }
            else if (ds.params && Array.isArray(ds.params)) {
                // old version
                const endpoint = ds.params.shift();
                loadImpl(ds.title, ds.color, endpoint, endpointParams(endpoint, ds.params));
            }
        }
        return Promise.all(resolvedDataSets).then((data) => data.filter((d) => d != null));
    };
}
export default function deriveLinkDefaults() {
    var _a, _b, _c, _d;
    const url = new URL(location.href);
    const hash = url.hash.slice(1);
    if (!hash) {
        return DEFAULT_VALUES;
    }
    try {
        const parsed = JSON.parse(atob(hash));
        return Object.assign(Object.assign({}, DEFAULT_VALUES), { active: [], showPoints: (_b = (_a = parsed.chart) === null || _a === void 0 ? void 0 : _a.showPoints) !== null && _b !== void 0 ? _b : DEFAULT_VALUES.showPoints, viewport: (_d = (_c = parsed.chart) === null || _c === void 0 ? void 0 : _c.viewport) !== null && _d !== void 0 ? _d : DEFAULT_VALUES.viewport, loader: initialLoader(parsed.datasets) });
    }
    catch (err) {
        history.pushState(null, document.title, '#');
        console.warn('invalid state in url', err);
        return DEFAULT_VALUES;
    }
}
export function getDirectLinkImpl(state) {
    var _a;
    const config = {
        chart: {
            viewport: (_a = state.viewport) !== null && _a !== void 0 ? _a : [0, 0, 0, 0],
            showPoints: state.showPoints,
        },
        datasets: [],
    };
    let anySkipped = false;
    state.active.forEach((data) => {
        if (data === SAMPLE_DATASET) {
            config.datasets.push({ title: data.title, color: data.color, params: {} });
            return;
        }
        if (data.params) {
            config.datasets.push({
                color: data.color,
                title: data.title,
                params: data.params,
            });
        }
        else {
            console.log('unable to get direct link to dataset:', data.title);
            anySkipped = true;
        }
    });
    const url = new URL(window.location.href);
    url.hash = `#${btoa(JSON.stringify(config))}`;
    return {
        url,
        anySkipped,
    };
}
